<template>
  <div class="orderList_item">
    <div class="item_header">
      <p>
        <a :href="orderLink" target="_blank">{{ orderHistory.order_key }}</a>
      </p>
      <span>{{ orderHistory.reg_date }}</span>
    </div>
    <div class="item_cont">
      <div class="tracker">
        <span class="state" :class="statusColor">{{
          orderHistory.status_name
        }}</span>
        <span>{{ checkFirst }}</span>
      </div>
      <ul>
        <li>
          <span>금액</span>
          <span><mpn-label-number :amount="orderHistory.total_price" /></span>
        </li>
        <li>
          <span>PV / BV</span>
          <span>
            <mpn-label-number :amount="orderHistory.total_pv" /> /
            <mpn-label-number
              :amount="orderHistory.total_bv"
              style="width: auto"
            />
          </span>
        </li>
        <li :style="firstStyle">
          <span>받는 분</span> <span>{{ orderHistory.recv_name }}</span>
        </li>
        <li :style="firstStyle">
          <span>전화번호</span> <span>{{ orderHistory.recv_phone }}</span>
        </li>
        <li :style="firstStyle">
          <span>주소</span>
          <span>[{{ orderHistory.zip }}] {{ orderHistory.addr }}</span>
        </li>
      </ul>
      <p v-if="onWarn" class="alert_msg">
        소분이 시작되어 주문 정보를 변경할 수 없습니다.
      </p>
      <history-item-btn-group
        :button-states="buttonStates"
        :delivery-change-btn="isDeliveryBtn"
        @on-cancel-order="onCancelOrder"
        @delivery-change="deliveryChange"
      />
    </div>
  </div>
</template>

<script>
import { ORDER_STATUS_CODE } from "@/utils/constants";
import mypackHelpers from "@/utils/helpers/mypack";
import HistoryItemBtnGroup from './HistoryItemBtnGroup.vue';

export default {
  name: "HistoryList",
  components: {
    HistoryItemBtnGroup,
  },
  props: {
    orderHistory: {
      type: Object,
      default: () => {},
    },
    reqNo: {
      type: Number,
      default: 0,
    },
    purchaseType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      orderLink: "",
    };
  },
  computed: {
    checkFirst() {
      if (this.purchaseType == "single") {
        return this.orderHistory.is_first ? "첫주문" : "재주문";
      } else {
        return this.orderHistory.seq + "회차";
      }
    },
    isDeliveryBtn() {
      if (!this.orderHistory.addr) {
        return false;
      }
      return true;
    },
    firstStyle() {
      if (
        !this.orderHistory.addr ||
        this.orderHistory.status === ORDER_STATUS_CODE.PAYMENT_CANCELED
      ) {
        return "visibility: hidden";
      }
      return "";
    },
    onWarn() {
      if (
        this.orderHistory.status === ORDER_STATUS_CODE.DIVISION_STARTED
      ) {
        return true;
      }
      return false;
    },
    buttonStates() {
      return mypackHelpers.getButtonStatesFromOrderStatus(
        this.orderHistory.status
      );
    },
    statusColor() {
      let color = "";
      switch (this.orderHistory.status) {
        case ORDER_STATUS_CODE.PAYMENT_FINISHED:
          color = "payment_confirm";
          break;
        case ORDER_STATUS_CODE.PAYMENT_CANCELED:
          color = "consulting_cancle";
          break;
        case ORDER_STATUS_CODE.DIVISION_STARTED:
          color = "subdivide";
          break;
        case ORDER_STATUS_CODE.DIVISION_FINISHED:
          color = "subdivide_confirm";
          break;
        default:
      }
      return color;
    },
    isGroupOrder() {
      return this.orderHistory.group_order_yn == "Y" ? true : false;
    },
  },
  created() {
    this.orderLink = `https://${process.env.SSO_HOST}/my-account/orders/${this.orderHistory.order_key}`;
  },
  methods: {
    onCancelOrder() {
      this.$emit("on-cancel-order");
    },
    deliveryChange() {
      if (this.isGroupOrder) {
        this.$emit("group-delivery-change", this.orderHistory.group_order_key);
      } else {
        this.$emit("delivery-change", this.orderHistory.order_key);
      }
    },
  },
};
</script>

<style scoped>
.item_cont {
  min-height: 160px;
}
</style>
